import React from 'react';

export default function PatientDetailsDrawer({ isOpen, onClose, data }) {
  if (!isOpen || !data) return null;

  const Field = ({ label, value, mono = false, accent = false }) => (
    <div className="pdd-field">
      <span className="pdd-field-label">{label}</span>
      <span
        className={`pdd-field-value${mono ? ' mono' : ''}${accent ? ' accent' : ''}`}
      >
        {value || '—'}
      </span>
    </div>
  );

  return (
    <>
      {/* Backdrop */}
      <div className="pdd-backdrop" onClick={onClose} />

      {/* Slide-in Drawer */}
      <aside className="pdd-drawer">
        {/* ── Header ── */}
        <div className="pdd-header">
          <div className="pdd-header-left">
            <div className="pdd-avatar">
              {(data.patientName || 'P')[0].toUpperCase()}
            </div>
            <div>
              <div className="pdd-patient-name">{data.patientName || 'Patient'}</div>
              <div className="pdd-patient-sub">
                {data.ageDisplay || '—'} &bull; {data.gender || '—'} &bull; UHID:{' '}
                <strong>{data.patientID || '—'}</strong>
              </div>
            </div>
          </div>
          <button className="pdd-close-btn" onClick={onClose} title="Close">
            &times;
          </button>
        </div>

        {/* ── Scrollable Body ── */}
        <div className="pdd-body">

          {/* Section: Patient */}
          <div className="pdd-section">
            <div className="pdd-section-label">PATIENT IDENTIFICATION</div>
            <div className="pdd-grid-2">
              <Field label="Full Name"      value={data.patientName} />
              <Field label="UHID"           value={data.patientID}      mono />
              <Field label="Age / Gender"   value={`${data.ageDisplay || '—'} / ${data.gender || '—'}`} />
              <Field label="Contact"        value={data.mobileNo || data.contactNo} />
            </div>
          </div>

          {/* Section: Order */}
          <div className="pdd-section">
            <div className="pdd-section-label">ORDER &amp; INVESTIGATION</div>
            <div className="pdd-grid-2">
              <Field label="Investigation"  value={data.testName || data.investigationName || 'Microbiology Culture'} accent />
              <Field label="Lab / Acc. No." value={data.ledgerTransactionNo} mono />
              <Field label="Clinician"      value={data.doctorName || 'SELF / DIRECT REFERRAL'} />
              <Field label="Ward / Dept."   value={data.wardName || data.department || 'Outpatient'} />
            </div>
          </div>

          {/* Section: Specimen */}
          <div className="pdd-section">
            <div className="pdd-section-label">SPECIMEN CHAIN OF CUSTODY</div>
            <div className="pdd-grid-2">
              <Field label="Specimen Type"  value={data.specimenName} accent />
              <Field label="Barcode / SIN"  value={data.barcodeNo}    mono />
              <Field label="Collected"      value={data.collectionDate ? new Date(data.collectionDate).toLocaleString() : '—'} />
              <Field label="Received"       value={data.receivedDate  ? new Date(data.receivedDate).toLocaleString()  : '—'} />
              <Field label="Inoculated"     value={data.inoculationDate ? new Date(data.inoculationDate).toLocaleString() : '—'} />
              <Field label="Days in Incubation" value={data.daysInIncubation !== undefined ? `Day ${data.daysInIncubation + 1}` : 'Day 1'} />
            </div>
          </div>

          {/* Section: History */}
          <div className="pdd-section">
            <div className="pdd-section-label">
              PRIOR MICROBIOLOGY HISTORY
              <span className="pdd-count-badge">{data.previousHistory?.length || 0}</span>
            </div>
            {data.previousHistory?.length > 0 ? (
              <div className="pdd-history-list">
                {data.previousHistory.slice(0, 5).map((h, i) => (
                  <div key={i} className="pdd-history-row">
                    <div className="pdd-history-top">
                      <span className="pdd-history-specimen">{h.specimenName || '—'}</span>
                      <span className="pdd-history-date">
                        {h.orderDate ? new Date(h.orderDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'}
                      </span>
                    </div>
                    <div className="pdd-history-organism">{h.organismSummary || 'No growth detected'}</div>
                    {h.resistantDrugsSummary && (
                      <div className="pdd-history-resistant">
                        R: {h.resistantDrugsSummary}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className="pdd-empty-state">No prior microbiology records for this patient.</div>
            )}
          </div>

        </div>

        {/* ── Footer ── */}
        <div className="pdd-footer">
          <button className="pdd-close-footer-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </aside>
    </>
  );
}
